module.exports = __webpack_public_path__ + "static/media/salary.672081e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/liveClasses/salary.png
// module id = 844
// module chunks = 6